import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { API_BASE_URL } from '@synergy/config';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RegionsApi } from '../api/regions-api';

const api = new RegionsApi(API_BASE_URL);

export interface GetRegionsParams {
    countryCode: string;
}

export interface SearchRegionsParams {
    search?: string | null;
    countryCodes: string[];
}

export const getRegionsByCountry = createAsyncThunk(
    'regions/getRegionsByCountry',
    async (params: GetRegionsParams, thunkAPI) => {
        const response = await api.getRegionsByCountry(params.countryCode);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }

        return { regions: response.result, countryCode: params.countryCode };
    }
);

export const searchRegions = createAsyncThunk(
    'regions/getRegions',
    async ({ search, countryCodes }: SearchRegionsParams, thunkAPI) => {
        const response = await api.searchRegions(search, countryCodes);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }

        return response.result;
    }
);

export const resetRegions = createAsyncThunk('regions/resetRegions', async () => {
    return null;
});
